// src/sections/landing/ContributionSection.jsx
import React from "react";

export default function ContributionSection({ api }) {
  const {
    Dropdown,
    t,
    contributionFrequency,
    setContributionFrequency,
    contributionFrequencyOptions,
    contributionAmount,
    setContributionAmount,
    contributionAmountOptions,
    contributionDedication,
    setContributionDedication,
    contributionReceiptEmail,
    setContributionReceiptEmail,
    contributionStatus,
    handleContributionSubmit,
  } = api || {};

  return (
    <section id="contribution" className="space-y-4">
      <h2 className="text-2xl sm:text-3xl font-semibold text-emerald-300">
        {t?.contributionSection?.heading || "Contribution"}
      </h2>
      <p className="text-sm sm:text-base text-slate-200 max-w-4xl">
        {t?.contributionSection?.sub ||
          "Fund contributions (financial). Choose frequency, amount, and optional dedication each time you contribute."}
      </p>

      <div className="rounded-3xl border border-slate-800/70 bg-[#010916]/85 p-6 space-y-4">
        <div className="grid gap-4 md:grid-cols-2">
          <div>
            <div className="text-xs text-slate-300 mb-2">
              {t?.contributionSection?.frequency || "Frequency"}
            </div>
            <Dropdown
              value={contributionFrequency}
              onChange={(v) => setContributionFrequency?.(v)}
              options={contributionFrequencyOptions || []}
              className="w-full"
              panelClassName="bg-[#061324] border border-slate-800"
            />
          </div>

          <div>
            <div className="text-xs text-slate-300 mb-2">
              {t?.contributionSection?.amount || "Amount"}
            </div>
            <Dropdown
              value={contributionAmount}
              onChange={(v) => setContributionAmount?.(v)}
              options={contributionAmountOptions || []}
              className="w-full"
              panelClassName="bg-[#061324] border border-slate-800"
            />
          </div>
        </div>

        <div>
          <div className="text-xs text-slate-300 mb-2">Email (for receipt)</div>
          <input
            className="w-full rounded-2xl border border-slate-700/60 bg-[#061324]/60 px-4 py-3 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/50"
            placeholder="you@example.com"
            value={contributionReceiptEmail || ""}
            onChange={(e) => setContributionReceiptEmail?.(e.target.value)}
          />
        </div>

        <div>
          <div className="text-xs text-slate-300 mb-2">
            {t?.contributionSection?.dedication || "Dedication / Memorial Note (optional)"}
          </div>
          <textarea
            className="w-full min-h-[100px] rounded-2xl border border-slate-700/60 bg-[#061324]/60 px-4 py-3 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/50"
            placeholder="Optional dedication / memorial note"
            value={contributionDedication || ""}
            onChange={(e) => setContributionDedication?.(e.target.value)}
          />
        </div>

        <div className="flex items-center gap-4">
          <button
            type="button"
            onClick={() => handleContributionSubmit?.()}
            disabled={contributionStatus === "loading"}
            className="rounded-2xl border border-cyan-500/40 bg-cyan-500/10 px-5 py-3 text-sm font-semibold text-cyan-200 hover:bg-cyan-500/15 transition disabled:opacity-60"
          >
            {t?.contributionSection?.submit || "Submit Contribution"}
          </button>

          {contributionStatus === "error" && (
            <span className="text-xs text-rose-300">Failed. Please try again.</span>
          )}
          {contributionStatus === "loading" && (
            <span className="text-xs text-slate-300">Submitting…</span>
          )}
          {contributionStatus === "sent" && (
            <span className="text-xs text-emerald-300">Submitted.</span>
          )}
        </div>
      </div>
    </section>
  );
}
